export interface PropertyAnytimeRatesVisibilityInput {
  /** Marketing traffic is always shown an anytime rate. */
  utmBp: string | undefined
  /** `PropertyOfferMapping.hasPromotions`. */
  mappingHasPromotions: boolean
  // TODO(HP-2326): Remove these fallbacks once the mapping endpoint reliably returns
  // `hasPromotions`.
  hasAlwaysOnPromotions: boolean
  hasBedbankPromotions: boolean
}

/**
 * Whether anytime rates may be surfaced for a property.
 *
 * This used to be implicit: server-side rendering only fetched anytime rates when the answer was
 * yes, so anywhere downstream could treat their presence in state as permission to display them.
 * Search tiles now fetch them too — for every LPC/LPP property on an anytime search, to find the
 * ones running a dynamic Flash campaign — so presence is no longer evidence on its own and each
 * display site has to ask.
 */
export function canSurfacePropertyAnytimeRates({
  utmBp,
  mappingHasPromotions,
  hasAlwaysOnPromotions,
  hasBedbankPromotions,
}: PropertyAnytimeRatesVisibilityInput): boolean {
  return !!utmBp || mappingHasPromotions || hasAlwaysOnPromotions || hasBedbankPromotions
}
